import { Provider, Type } from '@angular/core';
import { PushNotificationConfigService } from './push-notification-config.service';

export function providePushNotificationConfig(provider: Type<PushNotificationConfigService>): Provider {
  return {
    provide: PushNotificationConfigService,
    useClass: provider,
  };
}
